
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 22.5H.5a.5.5 0 01-.43-.75l11.5-20a.52.52 0 01.86 0l11.5 20a.5.5 0 01-.43.75zm-22.14-1h21.28L12 3z"}}),_c('path',{attrs:{"d":"M12.02 19.5a.5.5 0 01-.5-.5.5.5 0 01.5-.5.5.5 0 010 1zM12 16a.5.5 0 01-.5-.5v-7a.5.5 0 011 0v7a.5.5 0 01-.5.5z"}})])
          )
        }
      }
    